import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface SubmitModalProps {
  open: boolean;
  onClose: () => void;
  onRefresh?: () => Promise<void>;
  onSubmit: () => void;
  /** Optional container element for the portal (useful for fullscreen mode) */
  portalContainer?: HTMLElement | null;
}

export default function SubmitModal({
  open,
  onClose,
  onRefresh,
  onSubmit,
  portalContainer,
}: SubmitModalProps) {
  const handleClose = async () => {
    if (onRefresh) {
      await onRefresh();
    }
    onClose();
  };

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) handleClose();
      }}
    >
      <DialogContent className="max-w-md rounded-lg" showCloseButton={false} portalContainer={portalContainer}>
        <DialogHeader>
          <DialogTitle className="font-semibold text-lg text-gray-900 text-left mb-3">
            Are you sure you want to submit the code?
          </DialogTitle>
          <DialogDescription className="text-sm text-gray-600 text-left">
            Please make sure you have tested the code before submitting it.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="mt-2 flex flex-row gap-3 justify-end">
          <Button
            onClick={handleClose}
            variant="outline"
            className="py-3 rounded-lg"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            className="bg-[#062549] text-white py-3 rounded-lg hover:bg-[#083264] transition-colors"
          >
            Submit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
